import $ from 'jquery';
const MODULE_NAME = 'toggleNavbar';

export default angular.module(MODULE_NAME, [])
	.directive('toggleNavbar', function NavbarDirective() {
		return {
			restrict: 'A',
			link: function (scope, iElement, iAttrs) {
				$(iElement).click(function () {
					$(`#${iAttrs.toggleNavbar}`).toggleClass('in');
					$(iElement).toggleClass('collapsed');
					$(iElement).toggleClass('open');
				});
			}
		};
	}).name;



// WEBPACK FOOTER //
// ./source/modules/navbar/toggleNavbar.js